import React, { useState, useEffect } from 'react';
import { businessImageUpload, deleteBusinessImage, getBusinessImages, uploadBusinessImage } from '../../../../services/businessService';
import { toast } from "react-toastify";
import "../../../../css/business-images.css";
import { getImage } from '../../../../utils/cloudinarySizing';

const BusinessImages = ({ id }) => {
    const [photos, setPhotos] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [selectedPhoto, setSelectedPhoto] = useState(null);
    const [fullResSrc, setFullResSrc] = useState(null);

    const PLACEHOLDER = "/servspace-placeholder-500x500.png";

    // --- Fetch photos ---
    const fetchPhotos = async () => {
        try {
            const response = await getBusinessImages(id);
            setPhotos(response.images || []); // <-- ensure it's an array
        } catch (error) {
            console.error("Error fetching photos:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPhotos();
    }, []);

    // --- Click photo to enlarge ---
    const handleClickPhoto = (photo) => {
        setSelectedPhoto(photo);
        setFullResSrc(photo.image_800); // initial preview

        // Lazy load original full-res
        if (photo.image) {
            const img = new Image();
            img.src = photo.image;
            img.onload = () => setFullResSrc(photo.image);
        }
    };

    if (isLoading) return null;

    return (
        <div>

            <p
                style={{
                    color: "var(--text)",
                    textAlign: photos.length === 0 ? "center" : "right",
                    ...(photos.length === 0 && { marginTop: "20px" }),
                }}
            >
                {photos.length === 0
                    ? "No Images"
                    : `${photos.length} ${photos.length === 1 ? "Image" : "Images"}`}
            </p>

            <div className="photo-container">
                {photos.map((photo, index) => (
                    <div className="photo-box" key={index}>


                        <img
                            src={getImage(photo.image, "job_med")}
                            alt={`Photo ${index + 1}`}
                            onClick={() => handleClickPhoto(photo)}
                            style={{ cursor: "pointer" }}
                            onError={(e) => {
                                e.currentTarget.style.display = "none";
                            }}
                        />

                        {photo.description && <p>{photo.description}</p>}
                    </div>
                ))}
            </div>

            {selectedPhoto && (
                <div className="lightbox-backdrop" onClick={() => setSelectedPhoto(null)}>
                    <img
                        src={selectedPhoto.image}
                        alt="Full Size"
                        className="lightbox-image"
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>
            )}
        </div>
    );
};

export default BusinessImages;